export const TOGGLE_QUEUE_SELECT = '@@queueSelect/TOGGLE_QUEUE_SELECT';
export const SET_QUEUE = '@@queueSelect/SET_QUEUE';
export const SET_REGISTRATION_SERVICE_LOCATION = '@@queueSelect/SET_SERVICE_LOCATION';
export const SAVE_QUEUE_DATA = '@@queueSelect/SAVE_QUEUE_DATA';

export const setQueue = (queue, closeDialog) => ({
    type: SET_QUEUE,
    queue,
    closeDialog,
});

export const toggleQueueSelect = closeDialog => ({
    type: TOGGLE_QUEUE_SELECT,
    closeDialog,
});

export const setServiceLocation = (serviceLocation, closeDialog) => ({
    type: SET_REGISTRATION_SERVICE_LOCATION,
    serviceLocation,
    closeDialog,
});

export const saveQueueData = (queue, serviceLocation, status) => ({
    type: SAVE_QUEUE_DATA,
    queue,
    serviceLocation,
    status,
});
